import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

// Logical area: AppIndex General Strings
class Id {
  private constructor() {}

  public static readonly prefix = 'UI.webmodule-common.other.AppIndex.';

  public static readonly registerNew2FAApp = `${Id.prefix}registerNew2FAApp`;
  public static readonly enable2FA = `${Id.prefix}enable2FA`;
  public static readonly user = `${Id.prefix}user`;
  public static readonly logout = `${Id.prefix}logout`;
  public static readonly build = `${Id.prefix}build`;
  public static readonly welcome = `${Id.prefix}welcome`;
  public static readonly language = `${Id.prefix}language`;
  public static readonly setAsDefault = `${Id.prefix}setAsDefault`;
  public static readonly changeLanguage = `${Id.prefix}changeLanguage`;
  public static readonly devEnvironment = `${Id.prefix}devEnvironment`;
  public static readonly testEnvironment = `${Id.prefix}testEnvironment`;
}

export class LangAppIndex {
  private constructor() {}

  public static registerNew2FAApp(): string {
    return interpolate(Id.registerNew2FAApp);
  }

  public static enable2FA(): string {
    return interpolate(Id.enable2FA);
  }

  public static user(): string {
    return interpolate(Id.user);
  }

  public static logout(): string {
    return interpolate(Id.logout);
  }

  public static build(buildNumber: string): string {
    return interpolate(Id.build, { buildNumber });
  }

  public static welcome(user: string): string {
    return interpolate(Id.welcome, { user });
  }

  public static language(): string {
    return interpolate(Id.language);
  }

  public static setAsDefault(language: string): string {
    return interpolate(Id.setAsDefault, { language: language });
  }

  static changeLanguage(language: string) {
    return interpolate(Id.changeLanguage, { language: language });
  }

  public static devEnvironment(): string {
    return interpolate(Id.devEnvironment);
  }

  public static testEnvironment(): string {
    return interpolate(Id.testEnvironment);
  }
}

export class AppIndexModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // General
    register.add(Id.registerNew2FAApp, 'Register new 2FA App', 'Menu item for registering a new 2FA app');
    register.add(Id.enable2FA, 'Enable 2FA', 'Menu item for enabling 2FA');
    register.add(Id.user, 'User', 'Menu label for user');
    register.add(Id.logout, 'Logout', 'Menu item for logging out');
    register.add(Id.build, 'Build {{buildNumber}}', 'Build number display in footer');
    register.add(Id.welcome, 'Welcome {{user}}', 'Welcome message in user menu');
    register.add(Id.language, 'Language', 'Menu item for language selection');
    register.add(Id.setAsDefault, 'Set "{{language}}" as Default', 'Menu item to set language as default');
    register.add(
      Id.changeLanguage,
      'Changing language to "{{language}}" requires a page reload which may loose any current unsaved changes',
      'Confirm changing to a new display language which may loose unsaved changes'
    );
    register.add(Id.devEnvironment, 'DEV ENVIRONMENT', 'Footer label for dev environment');
    register.add(Id.testEnvironment, 'TEST ENVIRONMENT', 'Footer label for test environment');
  }
}
